import { baseBackend } from "../../../api/base/baseUrl";
import { getTokenRefresh } from "../../../helpers/token/refreshToken";

export async function getDriverMobileRequest(driverId) {
  try {
    const response = await baseBackend.get(`/api/v2/driver/mobile/${driverId}`, {
      headers: { Authorization: `Bearer ${getTokenRefresh()}` },
    });
    return { success: true, data: response.data?.data, error: null };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error.response?.status === 404
        ? "No se encontró el conductor."
        : "No se pudo cargar la información del conductor.",
    };
  }
}
